<template>
  <article>
    <section class="section">
      <div class="flex flex-col">
        <h1
          class="mb-[24px] flex flex-wrap items-center font-roboto text-[16px] font-medium leading-[16px] md:text-[32px] md:leading-[38px]"
        >
          Вы искали:
          <span v-if="request" class="ml-2 text-ruby-red-100"
            >{{ request }} ({{ meta?.total }} результатов)</span
          >
          <form v-else @submit.prevent>
            <input
              v-model="requestInputs"
              type="text"
              placeholder="введите поисковый запрос"
              class="ml-2 min-w-[24ch]"
              @focus="handleFocused(true)"
              @blur="handleFocused(false)"
              @keyup.enter="handleSubmit"
            />
          </form>
        </h1>
        <CommonComplexFiltering
          :key="isAnyFiltersActive"
          :rubrics-list="modelList"
          :filters-active="filters"
          rubric-placeholder="Форматы"
          is-centuries-disabled
          class="mb-[20px]"
          @on-reset-filters="handleResetFilters"
        />
      </div>
      <div v-if="results?.length" class="-m-2.5 flex flex-wrap">
        <MainPageCardsReworkedBaseCard
          v-for="(result, index) in results"
          :key="`search-result-${result.id}-${index}`"
          :data="result"
          is-small-title
          :title-length="60"
          disable-announce
          class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        />
      </div>
      <div
        v-else
        class="my-12 text-center font-roboto text-[32px] font-medium leading-[38px] text-new-gray-lighter"
      >
        Ничего не найдено
      </div>
      <div v-if="results?.length" class="my-14 flex justify-center">
        <BaseTheButtonNew
          v-if="searchResults.hasNextPage.value"
          text="Показать еще"
          @click="searchResults.fetchNextPage()"
        />
      </div>
    </section>
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
definePageMeta({
  layout: 'marginless',
});

const modelList = [
  { id: 1, label: 'Статьи', value: 'articles' },
  { id: 2, label: 'События', value: 'news' },
  { id: 3, label: 'Биографии', value: 'biographies' },
  { id: 4, label: 'Тесты', value: 'tests' },
  { id: 5, label: 'Видеоматериалы', value: 'videomaterials' },
  { id: 6, label: 'Авторы', value: 'authors' },
  { id: 7, label: 'Учителю', value: 'dirty-articles' },
];

const route = useRoute();
const router = useRouter();
const request = ref(route.query?.q ?? '');
const requestInputs = ref('');
const isInpunt = ref(false);
const model = computed(() =>
  route.query?.category ? +route.query.category : 0,
);

const filters = computed(() => {
  return {
    request: request.value,
    ...(model.value && { model: modelList[model.value - 1].value }),
    ...(model.value && { category: modelList[model.value - 1].id }),
  };
});

const handleResetFilters = () => (request.value = '');

const { searchResults, resetPage } = useSearch({ filters });

const results = computed(() => {
  if (isInpunt.value) return;
  return filters.value.model === 'dirty-articles'
    ? searchResults.data.value?.data.filter((item) => item.in_teacher)
    : searchResults.data.value?.data;
});

const meta = computed(() => searchResults?.data?.value?.meta);

watch(filters, (_, prevValue) => resetPage(prevValue));

watch(
  () => route.query,
  () => {
    if (route.query.q) {
      request.value = route.query.q;
    }
  },
);

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const handleFocused = (bool) => {
  isInpunt.value = bool;
  if (!bool) {
    request.value = requestInputs.value;
  }
};

const handleSubmit = () => {
  handleFocused(false);
  if (request.value) {
    router.push({ query: { q: request.value } });
    searchResults.refetch();
  }
};

useHead({
  title: 'Поиск по сайту',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: 'Поиск материалов на сайте История.РФ',
    },
    { hid: 'robots', name: 'robots', content: 'noindex' },
  ],
});
</script>

<style lang="scss"></style>
